import { Flow } from 'signup-constants/Flow';
import { getHistory } from '../../routing/history';
import { getTreatmentsClient } from '../../experiments/treatmentsClient';
export const TREATMENTS_EARLY_REQUEST_KEY = 'treatments-bulk-get';
const EXP_DISABLED_PARAM = 'exp-disabled';
export const makeBulkTreatmentsEarlyRequest = () => {
  const queryParams = new URLSearchParams(getHistory().location.search);
  const flowFromPath = getHistory().location.pathname.split('/')[1];
  const softwareSignupFlows = ['crm', 'marketing', 'sales', 'service', 'cms-free', 'academy'];
  const isAcademyEmbedded = flowFromPath === Flow.Academy && Boolean(queryParams.get('_seia'));
  const isPostVerificationFlow = queryParams.get('token');
  const shouldPreventRequest = queryParams.has(EXP_DISABLED_PARAM) || isPostVerificationFlow || !softwareSignupFlows.includes(flowFromPath) || isAcademyEmbedded;
  if (shouldPreventRequest) {
    return;
  }
  getTreatmentsClient().resolve();
};